var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileLikeSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 7,
  viewBox: "0 0 7 7",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.519 7S7 4.466 7 1.75C7 1.134 6.216 0 5.25 0S3.5.49 3.5 1.015C3.5.49 2.716 0 1.75 0S0 1.099 0 1.75C0 4.501 3.519 7 3.519 7"
})));
export default SvgPinterestMobileLikeSm;